import { JDSFileUploaderProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFileUploaderProps>
  ): React.FC<JDSFileUploaderProps> =>
  (props: JDSFileUploaderProps) => {
    return <Component {...props} />;
  };
